import { useEffect, useState } from 'react';
import './TogetherCounter.css';

const START_DATE = new Date('2016-03-19T15:00:00');

function addMonths(date, months) {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}

function getElapsed() {
  const now = new Date();
  let months =
    (now.getFullYear() - START_DATE.getFullYear()) * 12 +
    (now.getMonth() - START_DATE.getMonth());
  if (addMonths(START_DATE, months) > now) {
    months -= 1;
  }
  const diff = now.getTime() - addMonths(START_DATE, months).getTime();
  return {
    years: Math.floor(months / 12),
    months: months % 12,
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const pad = (n) => String(n).padStart(2, '0');

// Un clic sur le compteur passe à l'unité suivante (easter egg).
const TOTAUX = [
  { label: 'jours', ms: 1000 * 60 * 60 * 24 },
  { label: 'heures', ms: 1000 * 60 * 60 },
  { label: 'minutes', ms: 1000 * 60 },
  { label: 'secondes', ms: 1000 },
];

const formatNombre = (n) => n.toLocaleString('fr-FR');

function TogetherCounter() {
  const [elapsed, setElapsed] = useState(getElapsed());
  const [mode, setMode] = useState(-1);

  useEffect(() => {
    const interval = setInterval(() => setElapsed(getElapsed()), 1000);
    return () => clearInterval(interval);
  }, []);

  const nextMode = () => setMode((prev) => (prev + 1 < TOTAUX.length ? prev + 1 : -1));

  const units = [
    { value: elapsed.years, label: elapsed.years > 1 ? 'ans' : 'an' },
    { value: elapsed.months, label: 'mois' },
    { value: elapsed.days, label: elapsed.days > 1 ? 'jours' : 'jour' },
  ];

  const total = TOTAUX[mode];

  return (
    <span
      className="together-counter"
      role="button"
      tabIndex={0}
      onClick={nextMode}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          nextMode();
        }
      }}
    >
      {total ? (
        <span className="together-counter-unit">
          <strong>{formatNombre(Math.floor((Date.now() - START_DATE.getTime()) / total.ms))}</strong>{' '}
          {total.label}
        </span>
      ) : (
        <>
          {units.map((unit) => (
            <span className="together-counter-unit" key={unit.label}>
              <strong>{unit.value}</strong> {unit.label}
            </span>
          ))}
          <span className="together-counter-unit">
            <strong>
              {pad(elapsed.hours)}:{pad(elapsed.minutes)}:{pad(elapsed.seconds)}
            </strong>
          </span>
        </>
      )}
    </span>
  );
}

export default TogetherCounter;
